import styled from 'styled-components';

export const Title = styled.div`
  text-align: center;
  font-size: 24px;
  font-weight: normal;
  color: ${props => props.theme.colors.fontSilverDark};
  margin-bottom: 30px;  
`;



// WEBPACK FOOTER //
// ./src/modals/styled-components.js